import { render, staticRenderFns } from "./IrregularitiesMapPanel.vue?vue&type=template&id=2a809cae&scoped=true"
import script from "./IrregularitiesMapPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./IrregularitiesMapPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IrregularitiesMapPanel.vue?vue&type=style&index=0&id=2a809cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a809cae",
  null
  
)

export default component.exports